<template>
    <b-container fluid class="p-0">
        <situacao-licitacao :idLicitacao="licitacao.IdLicitacao" />
        <b-card class="mx-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center">
                    <span class="titulo-sagres font-weight-bold">
                        Detalhes da Licitação {{ licitacao.NumeroAnoLicitacao }}
                    </span>
                    <btn-voltar />
                    <btn-excluir v-if="modoExclusao" :excluirItem="callExcluir" :idItem="1" botao
                        class="float-right mt-1" />
                </h6>
            </template>
            <b-tabs card fill>
                <b-tab>
                    <template #title>
                        <font-awesome-icon icon="pencil" class="mr-1 text-info" v-b-tooltip.hover title="Dados Iniciais" />
                        <span class="d-none d-md-inline">Dados iniciais</span>
                    </template>
                    <detalhes-dados-gerais-dispensa-inexigibilidade v-if="licitacao.IsDispensaInexigibilidade"
                        :licitacao=licitacao></detalhes-dados-gerais-dispensa-inexigibilidade>
                    <detalhes-dados-gerais v-else :licitacao=licitacao></detalhes-dados-gerais>
                </b-tab>
                <b-tab v-if="!licitacao.IsDispensaInexigibilidade" lazy>
                    <template #title>
                        <font-awesome-icon icon="shopping-cart" class="mr-1 text-primary" v-b-tooltip.hover
                            :title="textoLoteItem" />
                        <span class="d-none d-md-inline">{{ textoLoteItem }}</span>
                    </template>
                    <detalhes-lotes-itens :licitacao=licitacao></detalhes-lotes-itens>
                </b-tab>
                <b-tab v-if="!licitacao.IsDispensaInexigibilidade" lazy>
                    <template #title>
                        <font-awesome-icon icon="address-card" class="mr-1 text-success" v-b-tooltip.hover
                            title="Participantes" />
                        <span class="d-none d-md-inline">Participantes</span>
                    </template>
                    <detalhes-participantes :licitacao=licitacao></detalhes-participantes>
                </b-tab>
                <b-tab title="Credores" v-if="licitacao.IsDispensaInexigibilidade" lazy>
                    <detalhes-participantes :licitacao=licitacao></detalhes-participantes>
                </b-tab>
                <b-tab v-if="!licitacao.IsDispensaInexigibilidade" lazy>
                    <template #title>
                        <font-awesome-icon icon="trophy" class="mr-1 text-warning" v-b-tooltip.hover title="Vencedores" />
                        <span class="d-none d-md-inline">Vencedores</span>
                    </template>
                    <detalhes-vencedores :licitacao=licitacao></detalhes-vencedores>
                </b-tab>
                <b-tab v-if="licitacao.IsDispensaInexigibilidade" lazy>
                    <template #title>
                        <font-awesome-icon icon="shopping-cart" class="mr-1 text-warning" v-b-tooltip.hover title="Itens" />
                        <span class="d-none d-md-inline">Itens</span>
                    </template>
                    <aba-editar-itens-di :lic="licitacao" ro></aba-editar-itens-di>
                </b-tab>
                <b-tab v-if="!licitacao.IsDispensaInexigibilidade && !licitacao.IsLote" lazy>
                    <template #title>
                        <font-awesome-icon icon="exclamation-triangle" class="mr-1 text-danger" v-b-tooltip.hover
                            title="Fracassados" />
                        <span class="d-none d-md-inline">Fracassados</span>
                    </template>
                    <detalhes-fracassados :idLicitacao="+licitacao.IdLicitacao"></detalhes-fracassados>
                </b-tab>
                <b-tab lazy>
                    <template #title>
                        <font-awesome-icon icon="hourglass-end" class="mr-1 text-secondary" v-b-tooltip.hover
                            title="Histórico" />
                        <span class="d-none d-md-inline">Histórico</span>
                    </template>
                    <detalhes-historico :idLicitacao="+idLicitacao"></detalhes-historico>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script lang="ts">
import DetalhesDadosGerais from '@/components/licitacoes/ldi/DetalhesDadosGerais.vue'
import DetalhesDadosGeraisDispensaInexigibilidade from '@/components/licitacoes/ldi/DetalhesDadosGeraisDispensaInexigibilidade.vue'
import DetalhesFracassados from '@/components/licitacoes/ldi/DetalhesFracassados.vue'
import DetalhesHistorico from '@/components/licitacoes/ldi/DetalhesHistorico.vue'
import DetalhesLotesItens from '@/components/licitacoes/ldi/DetalhesLotesItens.vue'
import DetalhesParticipantes from '@/components/licitacoes/ldi/DetalhesParticipantes.vue'
import DetalhesVencedores from '@/components/licitacoes/ldi/DetalhesVencedores.vue'
import SituacaoLicitacao from '@/components/licitacoes/ldi/SituacaoLicitacao.vue'
import AbaEditarItensDi from '@/components/licitacoes/ldi/editar-ldi/AbaEditarItensDi.vue'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import ldiService from '@/services/licitacoes/ldiService'
import { store } from "@/store"
import { fieldsLogsEventos } from '@/types/licitacoes/fields-logs-eventos'
import { Licitacao } from '@/types/licitacoes/ldi/licitacao'
import { LogEvento } from '@/types/licitacoes/log-evento'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'

const CompProps = Vue.extend({
    name: 'DetalhesLdi',
    components: {
        AbaEditarItensDi, BtnExcluir, BtnVoltar, DetalhesDadosGerais, DetalhesDadosGeraisDispensaInexigibilidade,
        DetalhesParticipantes, DetalhesVencedores, DetalhesFracassados, DetalhesLotesItens, DetalhesHistorico,
        SituacaoLicitacao
    },
    props: {
        idLicitacao: {
            type: String,
            required: true
        }
    }
})


@Component
export default class DetalhesLdi extends mixins(UtilsTS, CompProps) {
    tableBusy = false
    licitacao: Licitacao = new Licitacao()
    itemsLogs: LogEvento[] = []
    fieldsLogs: TableField[] = fieldsLogsEventos
    currentPageLogs = 1

    get modoExclusao() {
        return 'excluir' in this.$route.query
    }

    get textoLoteItem(): string {
        if (this.licitacao) return this.licitacao.IsLote ? 'Lotes' : 'Itens'
        return 'Lotes/Itens'
    }

    async created() {
        try {
            store.blockScreen = true
            this.licitacao = await ldiService.buscarDadosGerais(this.idLicitacao)
        }
        catch (e: any) {
            console.error('Erro ao montar detalhes de aditivo', e)
            this.$router.push("/modulo-licitacoes/aditivos-contratos");
            this.$toast.error(e.message || "Erro ao carregar aditivo");
        } finally {
            store.blockScreen = false
        }
    }

    async callExcluir() {
        try {
            store.blockScreen = true
            const response = await ldiService.removerLicitacao(+this.idLicitacao)
            if (response) {
                this.$toast.success('Licitação excluída com sucesso')
                this.$router.push("/modulo-licitacoes/licitacoes-dispensas-inexigibilidades");
            } else {
                this.$toast.error('Erro ao excluir licitação')
            }
        } catch (error: any) {
            this.tratarError(error)
        } finally {
            store.blockScreen = false
        }
    }

}
</script>

<style></style>